{
    "group": {
        "api_key": "Api keys",
        "capability": "Permissions",
        "cms": "Web edition",
        "company": "Companies",
        "company_abono": "AbonoTeatro company data",
        "discount": "Discounts",
        "discount_code": "Discount codes",
        "enclosure": "Enclosures",
        "enclosure_all": "Enclousures from all companies",
        "enclosure_type": "Enclosure types",
        "event": "Shows",
        "event_all": "Shows from all companies",
        "event_assessment": "Show assessments",
        "event_category": "Show categories",
        "event_change_status": "Events - Status",
        "event_change_status_to": "Events - Status",
        "event_prices": "Events - Subscriber and companion prices",
        "event_type": "Show types",
        "incidence": "Incidences",
        "market": "Markets",
        "notification": "Notificactions",
        "operation": "Operation",
        "person": "Persons",
        "province": "Provinces",
        "report": "Reports",
        "report_action": "Report actions",
        "role": "Roles",
        "role_market": "Market roles",
        "subscriber": "Subscribers",
        "subscription": "Subscriptions",
        "subscription_type": "Subscription types",
        "tax": "Taxes",
        "template": "General templates",
        "township": "Townships",
        "user": "Users",
        "user_assign_to": "Assign to",
        "user_can_be_incidences": "Incidence agents"
    }
}
